import { cn } from "@/util/cn";

type DividerProps = {
  className?: string;
};

export default function Divider({ className }: DividerProps) {
  return <div className={cn("border-t border-brand-neutral-600", className)} />;
}
